import { render, staticRenderFns } from "./OrderUpload.vue?vue&type=template&id=420aafc6&scoped=true&"
import script from "./OrderUpload.vue?vue&type=script&lang=js&"
export * from "./OrderUpload.vue?vue&type=script&lang=js&"
import style0 from "./OrderUpload.vue?vue&type=style&index=0&id=420aafc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420aafc6",
  null
  
)

export default component.exports